import productionDelayReducer from './productionDelayReducer';

export default productionDelayReducer;
